import React, { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";
import CryptoJS from "crypto-js";
import LoadingSpinner from "../components/LoadingSpinner";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { AlertSwal } from "../components/CustomSwal";

const CheckOpenId = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("頁面導入中 Redirecting ...");

  // 取得網址參數
  let { rawdata } = useParams();
  const config = props.config;
  const intl = useIntl();

  // 設備認證API
  const DeviceAuth = () => {
    const key = CryptoJS.enc.Utf8.parse("(055)2813338microprogram");
    const iv = CryptoJS.enc.Hex.parse("00000000");
    const encrypted = CryptoJS.enc.Hex.parse(rawdata).toString(
      CryptoJS.enc.Base64
    );
    const decrypted = CryptoJS.TripleDES.decrypt(encrypted, key, {
      iv: iv,
    }).toString(CryptoJS.enc.Utf8);
    const params = decrypted.split("&");
    const authid = params[0];
    const isblacklist = params[1];
    const cardnoexist = params[2];
    const userid = params[3];
    const sessiontime = moment(params[4], "YYYYMMDDHHmmss");
    // 2022-07-11 新增若 OPENID_EXPIRE_TIME 有值才做判斷，且判斷時 正/負(Math.abs) 皆納入失效條件
    const expired = config.OPENID_EXPIRE_TIME
      ? Math.abs(moment().diff(sessiontime, "minute")) >
        config.OPENID_EXPIRE_TIME
      : false;
    let invalidMsg = "";
    if (expired) invalidMsg = "SSO認證已失效";
    if (params.length !== 5) invalidMsg = "SSO參數錯誤";

    if (invalidMsg === "") {
      setLoading(true);
      axios
        .get(config.API_URL + `/DeviceAuth.aspx`, {
          params: {
            account: config.DEVICE_AUTH_ACC,
            password: config.DEVICE_AUTH_PASS,
            restype: "json",
          },
        })
        .then((res) => {
          const data = res.data[0];
          if (data.rescode === "1") {
            sessionStorage.setItem("userid", userid);
            sessionStorage.setItem(
              "logintime",
              moment().format("YYYY/MM/DD HH:mm:ss")
            );
            sessionStorage.setItem("authid", authid);
            sessionStorage.setItem("isblacklist", isblacklist);
            sessionStorage.setItem("cardnoexist", cardnoexist);
            sessionStorage.setItem("userstatus", "1");
            sessionStorage.setItem("sid", data.resdata[0].sid);
            props.history.push("/redirect_to/info");
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        })
        .catch((error) => {
          AlertSwal.fire({
            title: intl.formatMessage({ id: "global.alert_title" }),
            text: error,
            confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoadingMsg(invalidMsg);
      AlertSwal.fire({
        title: intl.formatMessage({ id: "global.alert_title" }),
        text: invalidMsg,
        confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
      });
    }
  };

  useEffect(DeviceAuth, []);

  return (
    <div className="text-center mt-3">
      <h5 className="font-bold">{loadingMsg}</h5>
      <LoadingSpinner loading={loading} />
    </div>
  );
};

export default CheckOpenId;
